import styles from "../YearSelector.module.scss";
import cx from "classnames";
import { ComponentPropsWithoutRef } from "react";
import SelectCard from "../../../../components/SelectCard";

type YearItemProps = Omit<ComponentPropsWithoutRef<"div">, "onChange"> & {
  year: number;
  onChange: (year: number) => void;
  selected: boolean;
  pseudoFocused: boolean;
  disabled: boolean;
};
export const YearItem = ({
  year,
  onChange,
  selected,
  pseudoFocused,
  disabled,
  onFocus,
  ...rest
}: YearItemProps) => {
  return (
    <SelectCard
      disabled={disabled}
      id={year}
      onChange={!disabled ? () => onChange(year) : () => {}}
      checked={selected}
      checkboxProps={{
        tabIndex: -1,
        onFocus,
      }}
      flexGrow={1}
      className={cx(styles["year-item"], {
        [styles["pseudo-focused"]]: pseudoFocused,
      })}
      data-year={year}
      tabIndex={-1}
      {...rest}
    >
      {year}
    </SelectCard>
  );
};
